import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import {
  StakeholderStoreActions,
  StakeholderStoreSelectors,
  StakeholderStoreReducer,
} from "./index";
import { CountryDto } from "@cradua/data";

@Injectable()
export class StakeholderFacade {
  constructor(
    private store: Store<StakeholderStoreReducer.StakeholderPartialState>,
  ) {}

  stakeholderRecord$ = this.store.select(StakeholderStoreSelectors.getSelected);
  stakeholderRecordError$ = this.store.select(
    StakeholderStoreSelectors.getStakeholderError,
  );

  getselected() {
    return this.store.select(StakeholderStoreSelectors.getSelected);
  }

  get isLoadingStakeholder() {
    this.store.dispatch(StakeholderStoreActions.loadStakeholder());
    return this.store.select(StakeholderStoreSelectors.loadingStakeholder);
  }

  get loadStakeholder() {
    this.store.dispatch(StakeholderStoreActions.loadStakeholder());
    return this.store.select(StakeholderStoreSelectors.getAllStakeholder);
  }

  addStakeholder(newStakeholder: any[]) {
    this.store.dispatch(
      StakeholderStoreActions.addStakeholder({ newStakeholder }),
    );
  }

  updateStakeholder(updateStakeholder: any[], deletedData: any[]) {
    this.store.dispatch(
      StakeholderStoreActions.updateStakeholder({
        updateStakeholder,
        deletedData,
      }),
    );
  }

  removeStakeholder(ids: string[]) {
    this.store.dispatch(StakeholderStoreActions.removeStakeholder({ ids }));
  }
}
